const Config = {
  APP_URL: 'http://www.wetter.com/wetterkarten/#',
  APP_CONFIG_URL: process.env.IS_DEV ? '/data/apps/maptool.json' : '/internal/wetterkarten/apps/maptool.json',
  APP_WARNINGS_URL: process.env.IS_DEV ? '/data/warnings/current.json' : '/internal/wetterkarten/warnings/current.json',
  APP_RECOMMENDATION_URL: process.env.IS_DEV ? '/data/empfehlungen/any.json' : '/internal/wetterkarten/empfehlungen/%product.json',
  APP_LIVECAMS_URL: process.env.IS_DEV ? '/data/livecams/all.json' : '/internal/wetterkarten/livecams/all.json',
  APP_VIDEOS_URL: process.env.IS_DEV ? '/data/videos/all.json' : '/internal/wetterkarten/videos/all.json',
  APP_WXNET_URL: 'http://geojson.wxnet.io/all/last/1/?type=geojson',
  headerItemCount: 5,
  rootDivId: 'maptool',
  DEBUG: false,
  adDivWrapper: 'mapToolWetterAdWrap',
  adDiv: 'mapToolWetterAd',
};

Config.DEFAULT_APP_CONFIG = {
  isMenuOpen: false,
  isFakeFullscreenOpen: false,
  isShortcutMenuOpen: false,
  isFullScreen: false,
  products: [],
  menuGroups: [],
  tabId: 'products',
  isLoading: true,
  basemaps: [],
  legendVisible: window.localStorage && JSON.parse(localStorage.getItem('additional-config')) ? JSON.parse(localStorage.getItem('additional-config')).legendVisible : false,
  currentY: null,
};

Config.DEFAULT_PRODUCT_CONFIG = {
  basemap: '',
  defaultBasemapId: '',
  timeNavigation: false,
  dataLayers: [],
  zoom: window.maptoolConfig && window.maptoolConfig.zoom ? window.maptoolConfig.zoom : 6,
  minZoom: 4,
  maxZoom: 10,
  maxBounds: [[-90, -180], [90, 180]], // southWest(latLng), northEast(latLng)
  id: '',
  title: '',
  description: '',
  currentTimestamp: null,
  map_legend: {
    ranges: [
      {
        scale_label: '',
        from: '',
        to: '',
        scale_icon: '',
        items: [],
      }
    ]
  },
  showWarnings: false,
  showFavorites: false,
  favorites: window.localStorage && JSON.parse(localStorage.getItem('favorite-store')) ? JSON.parse(localStorage.getItem('favorite-store')).favorites : [],
  isDescriptionOpen: false,
  productFamilyId: '',
};

Config.DEFAULT_PRODUCT_ID = 'niederschlagsradar';
Config.DEFAULT_GEO = [51.5, 10.3, 6];
Config.DEFAULT_ISPORTABLE = window.maptoolConfig.isPortable ? window.maptoolConfig.isPortable : false;

Config.getProductConfig = params => {
  let url = `/internal/wetterkarten/products/${params.config_url}`;
  if (process.env.IS_DEV) {
    url = `/data/products/${params.config_url}`;
  }
  return url;
};


if (typeof window.maptoolConfig === 'undefined') {
  console.warn('no initial map config provided');
}

export default Config;



/** WEBPACK FOOTER **
 ** ./apps/maptool/Config.js
 **/